import { Smartphone, Zap, Search, HeadphonesIcon, TrendingUp, Clock, Shield, Star } from 'lucide-react';

const TRUST_ITEMS = [
  { icon: Smartphone, label: 'Mobile-First' },
  { icon: Zap, label: 'Lightning Fast' },
  { icon: Search, label: 'SEO-Ready' },
  { icon: HeadphonesIcon, label: 'Personal Support' },
  { icon: TrendingUp, label: 'Built to Convert' },
  { icon: Clock, label: 'Quick Turnaround' },
  { icon: Shield, label: 'Secure & Reliable' },
  { icon: Star, label: 'Pixel Perfect' },
];

function MarqueeRow({ items }) {
  const doubled = [...items, ...items];
  return (
    <div className="flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
      <div className="flex gap-12 whitespace-nowrap animate-marquee">
        {doubled.map((item, i) => (
          <div
            key={`${item.label}-${i}`}
            data-testid={i < items.length ? `trust-item-${i}` : undefined}
            className="flex items-center gap-3 text-slate-500 dark:text-slate-500 flex-shrink-0 px-2"
          >
            <item.icon className="w-4 h-4 text-[#00E5FF]" strokeWidth={2.5} />
            <span className="text-sm font-semibold tracking-wide">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function TrustStrip() {
  return (
    <section id="trust" data-testid="trust-strip" className="py-10 md:py-14 border-y border-slate-100 dark:border-white/5 bg-[#FAFBFC] dark:bg-[#0D0D0D] overflow-hidden">
      <MarqueeRow items={TRUST_ITEMS} />
    </section>
  );
}
